import { HeadingPages } from '../../../components/HeadingPages'
import { CadastroCategoria } from './CadastroCategoria'
import { CadastroHome } from './CadastroHome'
import { CadastroProduto } from './CadastroProduto'
import { CadastroUltraRapido } from './CadastroUltraRapido'
import { Navigation } from './Navigation'

export const InnovationResponde = {
  Root: () => (
    <>
      <HeadingPages name="Innovation Responde" />
      <Navigation />
    </>
  ),
  Home: CadastroHome,
  UltraRapido: CadastroUltraRapido,
  Produto: CadastroProduto,
  Categoria: CadastroCategoria,
  Segmento: () => <div>Segmento</div>,
}
